/**
 * PreviewPanel - 3D preview with figure
 * Matches the Java SketchChair preview panel
 * Located in top-right corner, collapsible
 */

export class PreviewPanel {
    constructor(application, container) {
        this.app = application;
        this.container = container;
        this.isCollapsed = false;
        this.createPanel();
    }

    /**
     * Create the panel DOM structure
     */
    createPanel() {
        // Panel container
        const panel = document.createElement('div');
        panel.className = 'preview-panel';
        panel.style.cssText = `
            background: rgba(40, 40, 40, 0.95);
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            overflow: hidden;
            transition: all 0.3s;
        `;

        // Header
        const header = document.createElement('div');
        header.style.cssText = `
            background: rgba(30, 30, 30, 0.9);
            padding: 8px 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        `;

        const title = document.createElement('div');
        title.textContent = 'Preview';
        title.style.cssText = `
            color: var(--accent);
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
        `;
        header.appendChild(title);

        // Collapse button
        const collapseBtn = document.createElement('button');
        collapseBtn.textContent = '−';
        collapseBtn.style.cssText = `
            background: none;
            border: none;
            color: #aaa;
            font-size: 20px;
            cursor: pointer;
            padding: 0;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
        `;
        header.appendChild(collapseBtn);

        header.addEventListener('click', () => {
            this.toggleCollapse();
        });

        panel.appendChild(header);

        // Content area
        this.content = document.createElement('div');
        this.content.className = 'preview-content';
        this.content.style.cssText = `
            padding: 12px;
            width: 250px;
        `;

        // Preview canvas placeholder
        const previewCanvas = document.createElement('div');
        previewCanvas.style.cssText = `
            width: 100%;
            aspect-ratio: 1;
            background: rgba(20, 20, 20, 0.8);
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #666;
            font-size: 12px;
            margin-bottom: 12px;
        `;
        previewCanvas.textContent = '3D Preview';
        this.content.appendChild(previewCanvas);

        // Controls
        const controls = document.createElement('div');
        controls.style.cssText = `
            display: flex;
            justify-content: space-between;
            align-items: center;
        `;

        // Figure toggle
        const figureToggle = document.createElement('button');
        figureToggle.style.cssText = `
            background: rgba(60, 60, 60, 0.8);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 4px;
            color: #fff;
            padding: 6px 12px;
            cursor: pointer;
            font-size: 11px;
            transition: all 0.2s;
        `;
        figureToggle.innerHTML = '👁 Figure';
        figureToggle.title = 'Toggle ergonomic figure';
        figureToggle.addEventListener('click', () => {
            if (this.app.toggleRagdoll) {
                this.app.toggleRagdoll();
            }
        });
        controls.appendChild(figureToggle);

        // Figure size controls
        const sizeControls = document.createElement('div');
        sizeControls.style.cssText = 'display: flex; gap: 4px;';

        const minusBtn = document.createElement('button');
        minusBtn.textContent = '−';
        minusBtn.style.cssText = `
            background: rgba(60, 60, 60, 0.8);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 4px;
            color: #fff;
            width: 28px;
            height: 28px;
            cursor: pointer;
            font-size: 16px;
        `;
        minusBtn.title = 'Decrease figure size';
        minusBtn.addEventListener('click', () => {
            if (this.app.scaleRagdoll) {
                this.app.scaleRagdoll(0.9); // 10% smaller
            }
        });
        sizeControls.appendChild(minusBtn);

        const plusBtn = document.createElement('button');
        plusBtn.textContent = '+';
        plusBtn.style.cssText = `
            background: rgba(60, 60, 60, 0.8);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 4px;
            color: #fff;
            width: 28px;
            height: 28px;
            cursor: pointer;
            font-size: 16px;
        `;
        plusBtn.title = 'Increase figure size';
        plusBtn.addEventListener('click', () => {
            if (this.app.scaleRagdoll) {
                this.app.scaleRagdoll(1.1); // 10% bigger
            }
        });
        sizeControls.appendChild(plusBtn);

        controls.appendChild(sizeControls);
        this.content.appendChild(controls);

        panel.appendChild(this.content);
        this.container.appendChild(panel);

        this.panel = panel;
        this.collapseBtn = collapseBtn;
    }

    /**
     * Toggle collapse state
     */
    toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;

        if (this.isCollapsed) {
            this.content.style.display = 'none';
            this.collapseBtn.textContent = '+';
            this.panel.style.width = 'auto';
        } else {
            this.content.style.display = 'block';
            this.collapseBtn.textContent = '−';
            this.panel.style.width = '';
        }
    }

    /**
     * Update panel state
     */
    update() {
        // TODO: Update preview rendering
    }
}
